export default "__VITE_ASSET__C2R2CIiW__"